const DefaultConfig: Record<string, any> = {
    forceKeyFrameOnDiscontinuity: true,
    maxBufferHole: 0.5,
    maxAudioFramesDrift: 1,
    stretchShortVideoTrack: false
};

export default DefaultConfig;
